module.exports = "../../../../platform/assets/pageMainIcon/ig-business-processing-7.svg";